export enum SessionStatus {
  Active = 'Active',
  Authorizing = 'Authorizing',
  AuthorizationExpired = 'AuthorizationExpired',
  Failed = 'Failed',
  Success = 'Success',
}
